import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'jhi-file-select',
    templateUrl: './file-select.component.html',
    styleUrls: ['./file-select.component.scss']
})
export class FileSelectComponent {
    @ViewChild('fileUpload') fileUpload?: ElementRef;

    @Input() acceptedFileTypes: string = ''; // e.g., '.xlsx,.xls,.csv'
    @Input() buttonLabel: string = 'global.choose-file'; // Translation key
    @Input() noFileLabel: string = 'global.no-file'; // Translation key
    @Input() buttonClass: string = 'btn btn-info'; // Customizable button class
    @Input() showFileName: boolean = true; // Show/hide selected filename
    @Input() disabled: boolean = false; // Disable the upload
    @Input() multiple: boolean = false; // Multiple files upload
    @Input() showClearButton: boolean = false; // Show clear button when file selected

    @Output() fileSelected = new EventEmitter<any>();
    @Output() fileCleared = new EventEmitter<void>();

    fileName: string = '';
    fileNamePart: string = '';
    fileNameExt: string = '';

    openFileDialog(): void {
        // When the fileUpload input is clicked, automatically reset the file input so that
        // each time the file is selected, the file input is cleared and the file is read.
        this.clearFile();
        if (!this.disabled && this.fileUpload) {
            this.fileUpload.nativeElement.click();
        }
    }

    onFileChange(event: any): void {
        const file = event.target.files[0];
        if (file) {
            this.fileName = file.name;
            const lastDot = this.fileName.lastIndexOf('.');
            this.fileNamePart = this.fileName.substring(0, lastDot);
            this.fileNameExt = this.fileName.substring(lastDot);
            this.fileSelected.emit(event);
        }
    }

    clearFile(): void {
        this.fileName = '';
        this.fileNamePart = '';
        this.fileNameExt = '';
        if (this.fileUpload) {
            this.fileUpload.nativeElement.value = '';
        }
        this.fileCleared.emit();
    }

    hasFile(): boolean {
        return this.fileName !== null && this.fileName !== '';
    }
}
